import styled from 'styled-components'

const ShippingItemPrice = styled.div`
  display: inline-flex;
  align-items: center;
`

export default ShippingItemPrice
